import { Injectable } from "@angular/core";
import bulletTrain from "bullet-train-client";
import { environment as ENV } from "environments/environment";

@Injectable()
export class FeatureFlagService {
    // List all the feature flags here...
    hide_extra_reports = false;

  constructor() {
    const environmentID =  ENV.bullet_train_environmentID;
    bulletTrain.init({
      environmentID,
      onChange: () => {
        this.hide_extra_reports = bulletTrain.getAllFlags().hide_extra_reports.enabled
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/services/feature-flag/feature-flag.service.ts